module.exports = __webpack_public_path__ + "img/header-weddingRingsNaturalBeige.b76b0ec.jpg";